import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const GRADES = [
  { id: 'again', label: 'Kunde inte', hint: 'imorgon', bg: '#FFD1D1' },
  { id: 'hard', label: 'Svårt', hint: 'snart', bg: '#FFE8A3' },
  { id: 'ok', label: 'Okej', hint: 'nästa steg', bg: '#B9FBC0' },
  { id: 'easy', label: 'Lätt', hint: 'hoppa ett steg', bg: '#A2D2FF' },
];

export default function HpFlashcards({ refreshKey }) {
  const [deck, setDeck] = useState(null);
  const [idx, setIdx] = useState(0);
  const [flipped, setFlipped] = useState(false);
  const [practising, setPractising] = useState(false);

  const load = () => axios.get(`${API}/hp-daily/cards`, { withCredentials: true }).then((r) => { setDeck(r.data); setIdx(0); setFlipped(false); }).catch(() => {});
  useEffect(() => { load(); }, [refreshKey]);

  const grade = async (g) => {
    const card = deck.due[idx];
    try {
      const { data } = await axios.post(`${API}/hp-daily/cards/${card.id}/review`, { grade: g }, { withCredentials: true });
      setDeck((d) => ({ ...d, due_count: Math.max(0, d.due_count - 1), mastered: d.mastered + (data.level >= 5 && card.level < 5 ? 1 : 0) }));
      toast(`🃏 "${card.word}" kommer tillbaka om ${data.interval_days} ${data.interval_days === 1 ? 'dag' : 'dagar'}`);
    } catch { toast.error('Kunde inte spara'); return; }
    if (idx + 1 < deck.due.length) { setIdx(idx + 1); setFlipped(false); }
    else { setPractising(false); load(); toast.success('Alla dagens ordkort klara! 🐹💛'); }
  };

  if (!deck) return null;
  const card = practising ? deck.due[idx] : null;

  return (
    <section className="neo-card p-4 bg-white space-y-3" data-testid="hp-flashcards">
      <div className="flex items-baseline justify-between gap-2">
        <h4 className="font-['Fredoka'] font-bold text-lg">🃏 Ordkort i fickan</h4>
        <span className="text-[11px] opacity-60" data-testid="hp-cards-counts">{deck.total} kort · {deck.mastered} sitter · {deck.due_count} att repetera</span>
      </div>
      {!practising && (
        deck.due_count > 0 ? (
          <button onClick={() => setPractising(true)} className="neo-btn px-4 py-2 bg-[#FFC8DD] font-bold text-sm" data-testid="hp-cards-start">
            Repetera {deck.due_count} kort nu
          </button>
        ) : (
          <p className="text-xs opacity-70" data-testid="hp-cards-empty">
            {deck.total === 0 ? 'Gå en palatspromenad så blir orden till ordkort som kommer tillbaka precis innan du glömmer dem.'
              : `Inga kort att repetera idag. Nästa kort kommer ${deck.next_due} 🐹`}
          </p>
        )
      )}
      {card && (
        <div className="space-y-2">
          <button onClick={() => setFlipped(!flipped)} data-testid="hp-card-flip"
            className="w-full min-h-[150px] rounded-2xl border-[3px] border-black p-4 text-center transition-transform active:scale-[0.98]"
            style={{ background: flipped ? '#FFF8E1' : 'linear-gradient(135deg,#FFE8F5,#E8F0FF)' }}>
            <div className="text-[10px] font-bold uppercase tracking-widest opacity-50">{idx + 1}/{deck.due.length} · {flipped ? 'baksida' : 'tryck för att vända'}</div>
            <div className="font-['Fredoka'] text-3xl font-bold mt-2 text-[#D06892]" data-testid="hp-card-word">{card.word}</div>
            {flipped && (
              <div data-testid="hp-card-back">
                <div className="text-lg font-bold mt-1">= {card.meaning}</div>
                {card.scene && <p className="text-xs italic opacity-75 mt-2">📍 {card.location}: {card.scene}</p>}
              </div>
            )}
          </button>
          {flipped && (
            <div className="grid grid-cols-4 gap-2">
              {GRADES.map((g) => (
                <button key={g.id} onClick={() => grade(g.id)} className="rounded-xl border-2 border-black py-2 text-xs font-black hover:scale-105 transition-transform"
                  style={{ background: g.bg }} data-testid={`hp-card-grade-${g.id}`}>
                  {g.label}<div className="text-[9px] font-normal opacity-70">{g.hint}</div>
                </button>
              ))}
            </div>
          )}
        </div>
      )}
    </section>
  );
}
